export const MODULE = {
  careconneConsole: 'CARECONNE-CONSOLE',
};
